export default file => {
  const fileSizeInMB = file.size / (1024 * 1024);
  return fileSizeInMB > 0 && fileSizeInMB <= 20;
};
